module.exports = __webpack_public_path__ + "img/comment-dots-regular.31709259.svg";